import { $, $$ } from 'utils/dom';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { progress } from '../animations';

export const storyJumpmarks = () => {
  const story = $('.story');
  const sections = $$('.story-section:not(.story-section--cms)', story);
  const cmsSections = $$('.story-section.story-section--cms > *', story);

  [...sections, ...cmsSections].forEach(section => {
    ScrollTrigger.create({
      trigger: section,
      start: () => 'top+=10% bottom',
      end: () => 'bottom+=10% 99',
      toggleActions: 'play pause resume reset',
      onUpdate: self => progress(self),
    });
  });
};
